import Vue from 'vue'
import Router from 'vue-router'
import CandidatesForm from '@/views/candidates/form'
import Container from '@/containers/Container'
import Login from '@/views/login/login'
import ForgotForm from "@/views/login/forgot";
import ResetForm from "@/views/login/reset_password";

import Family from '@/views/family/index'
import Registrations from '@/views/registrations/index'
import Registrations_view from '@/views/view_registration/index'

Vue.use(Router)

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "Base",
      redirect: "/familia",
      component: Container,
      meta: {
        auth: true,
      },
      children: [
        {
          path: "/candidatar",
          name: "candidate",
          component: CandidatesForm,
          meta: {
            bodyClass: "candidate",
            scrollTo: "#page-container",
          },
        },
        {
          path: "inscricoes/:personId/:activityId",
          name: "registrations",
          component: Registrations,
        },
        {
          path: "familia",
          name: "family",
          component: Family,
        },
        {
          path: "view/:personId/:activityId",
          name: "view_registration",
          component: Registrations_view,
          props: true,
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/recuperar-palavra-passe",
      name: "forgot_password",
      component: ForgotForm,
    },
    {
      path: "/nova-palavra-passe/:token",
      name: "new_password",
      component: ResetForm,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      setTimeout(() => {
        var scrollTo = {};
        if (savedPosition) {
          console.log("return to " + savedPosition);
          scrollTo = savedPosition;
        } else if (to.meta.scrollTo) {
          console.log("scroll to " + to.meta.scrollTo);
          scrollTo = {
            selector: to.meta.scrollTo,
          };
        } else {
          console.log("scroll to 0 0");
          scrollTo = {
            x: 0,
            y: 0,
          };
        }
        resolve(scrollTo);
      }, 500);
    });
  },
});
